import styled from 'styled-components';
import { AssetLoader } from '@mews/framework';
import { Image } from '@optimus-web/core';

interface FlagIconProps {
    country: string;
    small?: boolean;
}

export const FlagIconElement = styled(Image)<Pick<FlagIconProps, 'small'>>`
    min-width: 24px;
    height: ${(props) => (props.small ? `18px` : `24px`)};
`;

const flagLoader = new AssetLoader({ assetDirectory: 'images/countryFlags' });
flagLoader.initialize().catch((error) => {
    throw error;
});

export const FlagIcon = (props: FlagIconProps) => {
    const { getAssetSrc, isInitialized } = flagLoader;

    return isInitialized ? <FlagIconElement src={getAssetSrc(`${props.country}.svg`)} small={props.small} /> : null;
};
